const FineCharges = {

    // PAGE HEADER
    "fineCharges": "Fine Charges",
    "yes": "Yes",
    "no": "No",
    "load_error": "Something went wrong. Unable to load details.",
    "created_at": "Created",
    "no_description": "No description provided.",

    // FIELDS
    "premise": "Premise",
    "target_group": "Target Group",
    "zone": "Zone",
    "level": "Level",
    "unit": "Unit",
    "charges_type": "Charges Type",
    "amount": "Amount",
    "description": "Description",
    "add_invoice": "Add to Billing",
    "tax_applicable": "Tax Applicable",
    "status": "Status",
    "date": "Date",
    "search": "Search",

    // TABLE HEADERS
    "table_premise": "PREMISE",
    "table_charges_type": "CHARGES TYPE",
    "table_amount": "AMOUNT",
    "table_add_invoice": "BILLING",
    "table_tax_applicable": "TAXABLE",
    "table_status": "STATUS",
    "table_fine_status": "FINE STATUS",
    "table_date": "DATE",

    // PAYMENT DETAILS
    "payment_details": "Payment Details",
    "billing_charge_amount": "Charge Amount",
    "billing_discount_amount": "Discount Amount",
    "billing_tax_amount": "Tax Amount",
    "billing_total_amount": "Total Amount",
    "billing_paid_amount": "Paid Amount",

    // ERROR
    "error_premise": "Select Premise",
    "error_charge_type": "Select Charges Type",
    "error_amount": "Enter Amount",
    "error_amount_positive": "Amount cannot be negative",
    "error_add_invoice": "Select Add to Billing",
    "error_tax_applicable": "Select Tax Applicable",
}

export default FineCharges;